export enum IObjectSelectActionTypes {
	OpenFolder,
	GoBack
}
